import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(1.25),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderPrimaryLight,
      borderRadius: theme.shape.borderRadius,

      transition: theme.transitions.create(['border-color'], {
        duration: theme.transitions.duration.short,
      }),

      '&:hover': {
        borderColor: COLORS.primary.default,
      },
    },

    header: {},
    details: {},
  }),
  { name: 'DetectedBrandTerm' }
);
